import { AbstractEntity } from "..";
export class BookKeyBundle extends AbstractEntity {
    author;
    book;
    startTime;
    endTime;
    keys = [];
    signature;
    constructor(bookKeyBundle = {}) {
        super();
        Object.assign(this, bookKeyBundle);
    }
}
//# sourceMappingURL=bookKeyBundle.js.map